<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div v-if="type != 'save'">
        <span>采购计划单号：</span>
        <span>{{ form.bizNo }}</span>
      </div>
    </div>

    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-row :gutter="20" type="flex">
        <el-col :span="12" :xs="12">
          <el-form-item label="计划名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入">
              <el-popover
                slot="suffix"
                placement="bottom-start"
                title="填写要求："
                width="200"
                trigger="hover"
                popper-class="form-tips"
                content="客户名称_月份_采购计划 示例：亚太健康_9月_采购计划">
                <i
                  class="el-icon-warning-outline"
                  slot="reference">
                </i>
              </el-popover>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="客户名称" prop="customerId">
            <el-select
              v-model="form.customerId"
              collapse-tags
              filterable
              multiple
              placeholder="请选择"
              @change="factoryChange"
            >
              <el-option
                v-for="(item, index) in customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="备注">
            <el-input
              :rows="3"
              type="textarea"
              resize="none"
              maxlength="300"
              v-model="form.remark"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">计划信息</div>
          <el-button class="line-button" icon="el-icon-plus" @click="handleAddRow">新增行</el-button>
        </div>
      </div>

      <TablePublic
        :colLists="colLists"
        :tableData="form.itemReqList"
        :paginationFlag="false"
        :nonMargin="true"
        :headerCellClassMethod="addStar"
        :summary="true"
        :summaryMethod="getSummaries"
      >
        <template slot="solts" slot-scope="scope">
          <el-button class="delbutton" type="text" size="small" @click="handleDel(scope.index)">删除</el-button>
        </template>
        <template slot="cultivationMethodSpecAttrKey" slot-scope="scope">
          <el-form-item
            :prop="'itemReqList.' + scope.index + '.cultivationMethodSpecAttrKey'"
            :rules="rules.cultivationMethodSpecAttrKey"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.cultivationMethodSpecAttrKey"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.cultivationMethodSpecAttrKey,
                  scope.index,
                  cultivationList,
                  'cultivationMethodSpecValueKey'
                )
              "
            >
              <el-option
                v-for="item in cultivationList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="ripenessLevelSpecAttrKey" slot-scope="scope">
          <el-form-item>
            <el-select
              v-model="scope.data.ripenessLevelSpecAttrKey"
              filterable
              multiple
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.ripenessLevelSpecAttrKey,
                  scope.index,
                  ripenessList,
                  'ripenessLevelSpecValueKey',
                  true
                )
              "
            >
              <el-option
                v-for="item in ripenessList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="planToPurchaseNetWeight" slot-scope="scope">
          <el-form-item
            :prop="'itemReqList.' + scope.index + '.planToPurchaseNetWeight'"
            :rules="rules.planToPurchaseNetWeight"
            :show-message="false"
          >
            <el-input v-model="scope.data.planToPurchaseNetWeight" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
      </TablePublic>

      <div class="attachment-info">
        <div class="title title-mt title-mb">
          <div class="title-block">
            <div class="block"></div>
            <div class="titleText title-mr">上传附件</div>
            <el-upload
              class="upload-demo"
              :headers="importHeaders"
              :action="uploadPath"
              accept=".jpg, .jpeg, .png, .webp, .gif, .bmp, .pdf, .dwg, .dxf, .xls, .xlsx, .doc, .docx, .txt, .mp4, .avi"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeFileUpload"
              :on-progress="handelProgress"
            >
              <el-button class="line-button" icon="el-icon-plus">上传附件</el-button>
            </el-upload>
          </div>
        </div>

        <Attachment
          v-if="fileData && fileData.length > 0"
          :fileList="fileData"
          :is-examine="true"
          :isEdit="true"
          @on-del="handleDelFile"
          :showFileType="false"
        ></Attachment>
        <div v-else class="no-contract-type">暂无内容</div>
      </div>

      <div class="title title-mt title-mb" v-if="type == 'update'">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">修改原因</div>
          <el-popover
            placement="right-end"
            width="900"
            trigger="manual"
            v-model="visible"
          >
            <div>
              <div class="popover_title">
                <div>修改记录</div>
                <div class="el-icon-circle-close" @click="visible = false"></div>
              </div>
              <TablePublic :colLists="colLists2" :showIndex="false" :tableData="tableData2" tableHeight="400" :paginationFlag="false">
                <template slot="modificationDesc" slot-scope="scope">
                  <el-tooltip :disabled="!scope.data.modificationDesc" :content="scope.data.modificationDesc" placement="top" popper-class="custom-tooltip-width">
                    <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
                  </el-tooltip>
                </template>
              </TablePublic>
            </div>
            <el-button slot="reference" class="line-button" @click="visible = true">修改记录</el-button>
          </el-popover>
        </div>
      </div>
      <el-row :gutter="20" v-if="type == 'update'">
        <el-col :span="24" :xs="12">
          <el-form-item label="修改原因" prop="reason">
            <el-input
              :rows="3"
              resize="none"
              type="textarea"
              maxlength="300"
              v-model="form.reason"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadPath } from '@/api/system/system'
import { getDropFactoryList, modifyPurchasePlan, getPurchasePlanDetail, getAmdRecList } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic.vue'
import Attachment from '@/components/attachment.vue'
export default {
  components: {
    TablePublic,
    Attachment,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      dialogVisible: false,
      colLists2: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
          align: 'left'
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          align: 'left'
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100'
        },
      ],
      tableData2: [],
      colLists: [
        {
          prop: 'cultivationMethodSpecAttrKey',
          label: '培育方式',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'ripenessLevelSpecAttrKey',
          label: '成熟度',
          isTrue: true,
          formSolt: true,
          width: 320,
        },
        {
          prop: 'planToPurchaseNetWeight',
          label: '计划采购总净重(斤)',
          isTrue: true,
          formSolt: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      form: {
        id: '',
        name: '',
        remark: '',
        list: [],
        customerId: [],
        itemReqList: [],
        attachmentReqList: [],
        reason: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        customerId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        cultivationMethodSpecAttrKey: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        planToPurchaseNetWeight: [{ required: true, message: '请输入', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入修改原因', trigger: 'blur' }],
      },
      customerList: [
        {
          id:1,
          name:'22'
        }
      ],
      tableData: [],
      fileData: [],
    }
  },
  computed: {
    ...mapState({
      cultivationList: (state) => (state.system.dictList && state.system.dictList.cultivationMethod) || [],
      ripenessList: (state) => (state.system.dictList && state.system.dictList.ripenessLevel) || [],
    }),
    uploadPath() {
      return uploadPath()
    },
    importHeaders() {
      const token = sessionStorage.getItem('token')
      return { Authorization: 'Bearer ' + token }
    },
  },
  created(){
    this.getDropFactoryList()
  },
  methods: {
    getDropFactoryList(){
      getDropFactoryList({type: 1}).then((res) => {
        if (res.flag) {
          this.customerList = res.data
        }
      })
    },
    factoryChange(customerList) {
      let currentCusList = this.customerList.filter((item) => {
        return customerList.includes(item.id)
      })
      let currentCusNameList = currentCusList.map((ele) => {
        return {
          customerAbbrev: ele.customerAbbrev,
          processFactoryId: ele.id,
          customerName: ele.name,
        }
      })
      this.form.list = currentCusNameList
    },
    getDetails(row) {
      getPurchasePlanDetail(row.id).then((res) => {
        if (res.flag) {
          let row = res.data
          this.form = Object.assign(this.form, {
            ...row,
            customerId: row.list.map(d => d.processFactoryId),
            itemReqList: row.itemRespList.map((d) => {
              delete d.id
              d.ripenessLevelSpecAttrKey = d.ripenessLevelSpecAttrKey ? d.ripenessLevelSpecAttrKey.split(',') : []
              d.ripenessLevelSpecValueKey = d.ripenessLevelSpecValueKey ? d.ripenessLevelSpecValueKey.split(',') : []
              return d
            }),
          })
          this.fileData =
            (row.attachmentRespList &&
              row.attachmentRespList.map((f) => {
                return {
                  ...f,
                  fileUrl: f.url,
                  fileName: f.name,
                  fileType: f.type,
                  fileSuffix: f.name.substring(f.name.lastIndexOf('.') + 1)
                }
              })) ||
            []
          this.getAmdRecList(row.id)
        }
      })
    },
    getAmdRecList(id){
      getAmdRecList({formId: id, formType: 'purchase_plan'}).then(res => {
        if (res.flag) {
          this.tableData2 = res.data.map(d=>{
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            return d
          })
        }
      })
    },
    checkDuplicatesInGroup(list, groupKey, checkKey) {
      // 按照groupKey进行分组
      const groupedData = {};
      list.forEach(item => {
          const key = item[groupKey];
          if (!groupedData[key]) {
              groupedData[key] = [];
          }
          groupedData[key].push(item);
      });

      // 检查每个分组中checkKey是否有重复数据
      const result = {};
      for (const groupKey in groupedData) {
          const group = groupedData[groupKey];
          const hasDuplicates = checkDuplicatesInGroupFunc(group);
          result[groupKey] = hasDuplicates;
      }
      function checkDuplicatesInGroupFunc(group){
        const seen = new Set();
        for (const item of group) {
            const attrKeys = item[checkKey];
            if(!attrKeys.length){
              if (seen.has(0)) {
                  return true;
              }
              seen.add(0);
            }
            for (const key of attrKeys) {
                if (seen.has(key)) {
                    return true;
                }
                seen.add(key);
            }
        }
        return false;
      }

      return result;
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            if (!this.form.itemReqList.length) {
              this.$message.error('请新增至少一条计划信息')
              return reject()
            }
            const repeatResult = this.checkDuplicatesInGroup(this.form.itemReqList, 'cultivationMethodSpecValueKey', 'ripenessLevelSpecAttrKey')
            const isRepeat = Object.values(repeatResult).some(value => value === true);
            if (isRepeat) {
              this.$message.error('存在相同培育方式在相同成熟度上有重复使用，请检查！')
              return reject()
            }
            let reg = /^([1-9][0-9]*)+(\.[0-9]{1,6})?$/
            let numFlag = this.form.itemReqList.some((d) => {
              if (!reg.test(d.planToPurchaseNetWeight)) {
                return true
              }
            })
            if (numFlag) {
              this.$message.error('计划采购总净重(斤)只能为正整数或小数，请检查！')
              return reject()
            }
            this.form.attachmentReqList =
              this.fileData &&
              this.fileData.map((f) => {
                return {
                  url: f.fileUrl,
                  name: f.fileName,
                  type: f.fileType,
                }
              })
            let formData = this.deepClone(this.form)
            formData.itemReqList = formData.itemReqList.map(v=>{
              return {
                ...v,
                ripenessLevelSpecAttrKey: v.ripenessLevelSpecAttrKey.join(','),
                ripenessLevelSpecValueKey: v.ripenessLevelSpecValueKey.join(','),
              }
            })
           
            let result = await modifyPurchasePlan(formData, this.type)
            if (result.code == 200 && result.flag) {
              this.$message.success(`${this.type == 'update'?'修改':'提交'}成功`)
              resolve()
            } else {
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset() {
      // this.fileData = []
      // this.resetForm('form')
      // this.form.attachmentReqList = []
      // this.form.itemReqList = []
      // this.form.remark = ''
      // this.form.id = ''
      // this.visible = false
    },
    handleAddRow() {
      this.form.itemReqList.push({
        cultivationMethodSpecAttrKey: '',
        cultivationMethodSpecValueKey: '',
        ripenessLevelSpecAttrKey: [],
        ripenessLevelSpecValueKey: [],
        planToPurchaseNetWeight: '',
      })
    },
    handleChange(value, index, list, fieldName, multiple) {
      if(multiple){
        const result = [];
        for (let i = 0; i < value.length; i++) {
            const currentId = value[i];
            const matchedObj = list.find(item => item.dictValue === currentId);
            if (matchedObj) {
                result.push(matchedObj.dictLabel);
            }
        }
        this.form.itemReqList[index][fieldName] = result
      }else{
        this.form.itemReqList[index][fieldName] = list.find((item) => item.dictValue == value).dictLabel
      }
    },
    handleAvatarError() {
      this.$message.error('上传失败')
      this.$emit('on-upload', { fileUploading: false })
    },
    handelProgress() {
      this.$emit('on-upload', { fileUploading: true })
    },
    handleAvatarSuccess(res) {
      const fileType = this.fileInfo(res.data).type
      const fileName = this.fileInfo(res.data).name
      const fileUrl = this.fileInfo(res.data).url
      const fileSuffix = this.fileInfo(res.data).suffix
      this.fileData.push({
        fileName,
        fileType,
        fileUrl,
        fileSuffix
      })
      this.$message.success('上传成功！')
      this.$emit('on-upload', { fileUploading: false })
    },
    handleDel(index) {
      this.form.itemReqList.splice(index, 1)
    },
    handleDelFile(data) {
      this.fileData.splice(data.index, 1)
    },
    addStar(obj) {
      if (this.type != 'preview') {
        if (obj.columnIndex === 1 || obj.columnIndex === 3) {
          return 'star'
        }
      }
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计(斤)'
          return
        }
        if (index === 3) {
          sums[index] = this.sumArr(data, 'planToPurchaseNetWeight') || '-'
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';
.el-icon-warning-outline{
  margin-top: 6px;
  font-size: 26px;
  color: #000;
  cursor: pointer;
}
/deep/ .el-select {
  width: 100%;
}
</style>
<style>
.form-tips {
  color: red;
}
</style>